export default __webpack_public_path__ + "static/media/scrolldown.f85159c1.svg";